var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<textarea (input)></textarea>"}],
    template = twig({"id":"$resolved:624b1a4769799c453efa886f1db645501699893166e00c878030b7c72fd4a856118bce3ac257ac06da7121d6cb225538a3c7f840002b8cf3bd219aef938e9f14:magic-input-code.twig","data":[{"type":"raw","value":"<textarea (input)></textarea>"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;